module.exports = __webpack_public_path__ + "img/mini.259b01d4.png";